(function () {
  'use strict';
  const config = window.PT_DISCOUNTS;
  if (!config) return;
  const firstCode = 'NEWCUSTOMER25', ttl = 72 * 60 * 60 * 1000;
  const root = window.Shopify?.routes?.root || '/';
  const url = new URL(location.href);
  const incoming = url.searchParams.get('pt_offer') || url.searchParams.get('discount');
  const isCart = /\/cart\/?$/.test(url.pathname);
  let cart, working = false, error = '', queue = Promise.resolve(), cartUpdating = false;
  const normal = value => String(value || '').trim().toUpperCase();
  const codes = value => (value.discount_codes || []).map(d => normal(d.code)).filter(Boolean);
  const metadata = value => { try { return JSON.parse(value.attributes?._pt_discount_state || '{}'); } catch (_) { return {}; } };
  async function request(path, body) {
    const response = await fetch(root + path, { credentials: 'same-origin', cache: 'no-store', ...(body ? {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)} : {}) });
    if (!response.ok) throw new Error(config.text.error);
    return response.json();
  }
  async function replace(list, state) {
    return request('cart/update.js', {discount:list.join(','),attributes:{_pt_discount_state:JSON.stringify(state)}});
  }
  function render() {
    document.querySelectorAll('[data-pt-discount-panel]').forEach(panel => {
      panel.replaceChildren();
      panel.setAttribute('aria-live','polite');
      const applied = cart?.discount_codes || [];
      panel.hidden = cart?.item_count === 0 || (!applied.length && !error);
      if (cart?.item_count === 0) return;
      applied.forEach(discount => {
        const row = document.createElement('div'); row.className='pt-discount-row';
        const text = document.createElement('span');
        const name=normal(discount.code);
        text.textContent=name;
        const status = document.createElement('small');
        status.textContent = name===firstCode && config.repeatBuyer ? config.text.ineligible : discount.applicable===false ? config.text.unavailable : config.text.check;
        text.append(status);
        const button=document.createElement('button');button.type='button';button.textContent=config.text.remove;button.disabled=working;button.setAttribute('aria-label',config.text.remove+' '+name);
        button.addEventListener('click',()=>run(async()=>{
          cart=await request('cart.js');const state=metadata(cart);delete state.firstAppliedAt;
          const next=codes(cart).filter(c=>c!==name);state.codes=next;
          cart=await replace(next,state);if(isCart)location.reload();else document.dispatchEvent(new CustomEvent('pt:discount-changed'));
        }));row.append(text,button);panel.append(row);
      });
      if(error){const p=document.createElement('p');p.textContent=error;panel.append(p);}
    });
  }
  function run(task) {
    queue=queue.catch(()=>{}).then(async()=>{working=true;error='';render();try{return await task();}catch(e){error=config.text.error;throw e;}finally{working=false;render();}});
    queue.catch(()=>{});return queue;
  }
  async function reconcile(offer) {
    cart=await request('cart.js');let list=codes(cart),state=metadata(cart),next=list.slice();
    if (cart.item_count === 0) {
      const stale = list.length > 0 || Boolean(cart.attributes?._pt_discount_state);
      if (stale) cart = await request('cart/update.js', {discount:'', attributes:{_pt_discount_state:''}});
      return stale;
    }
    const now=Date.now();
    const originalTime=state.firstAppliedAt;
    if(offer){
      next=String(offer).split(',').map(normal).filter(Boolean);
      state={codes:next,firstAppliedAt:next.includes(firstCode)?now:null};
    }else{
      const added=list.filter(c=>!(state.codes||[]).includes(c));
      if(state.codes?.length && added.length){next=added;state.firstAppliedAt=added.includes(firstCode)?now:null;}
      if(next.includes(firstCode) && !state.firstAppliedAt) state.firstAppliedAt=now;
      if(next.includes(firstCode) && now-state.firstAppliedAt>=ttl){
        next=next.filter(c=>c!==firstCode);delete state.firstAppliedAt;
      }
      state.codes=next;
    }
    const changed=JSON.stringify(next)!==JSON.stringify(list);
    if(offer || changed || state.firstAppliedAt!==originalTime)cart=await replace(next,state);
    return changed;
  }

  // One cart action at a time. Show feedback before waiting for Shopify.
  function changeCart(control, body, clearAll) {
    if (cartUpdating) return;
    cartUpdating = true;
    const form = document.getElementById('cartForm');
    const controls = [...document.querySelectorAll('#cartForm button,#cartForm input,#cartForm a[data-pt-cart-remove],#cartForm a[data-pt-cart-clear],[data-cart-sticky] button')];
    const previous = controls.map(el => [el, el.disabled, el.getAttribute('aria-disabled')]);
    const label = control.textContent;
    form?.setAttribute('aria-busy','true');
    controls.forEach(el => {if ('disabled' in el) el.disabled = true; el.setAttribute('aria-disabled','true');});
    if (control.matches('a')) control.textContent = label.trim() + '…';
    const row = control.closest('tr');
    if (row) row.style.opacity = '.5';
    const message = document.querySelector('[data-pt-cart-error]');
    if (message) message.hidden = true;
    run(async () => {
      cart = await request(clearAll ? 'cart/clear.js' : 'cart/change.js', body || {});
      if (cart.item_count === 0) cart = await request('cart/update.js', {discount:'',attributes:{_pt_discount_state:''}});
      render();
      // Keep a draft-theme preview when testing; discard incoming offer parameters.
      const destination = new URL(root+'cart', location.origin);
      if (url.searchParams.has('preview_theme_id')) destination.searchParams.set('preview_theme_id',url.searchParams.get('preview_theme_id'));
      location.replace(destination.href);
    }).catch(() => {
      cartUpdating = false;
      form?.removeAttribute('aria-busy');
      previous.forEach(([el,disabled,aria]) => {if ('disabled' in el) el.disabled=disabled; if(aria===null)el.removeAttribute('aria-disabled');else el.setAttribute('aria-disabled',aria);});
      control.textContent = label;
      if (row) row.style.opacity = '';
      if (message) {message.textContent=config.text.error;message.hidden=false;}
    });
  }
  document.addEventListener('click', event => {
    const control = event.target.closest('[data-pt-cart-remove],[data-pt-cart-clear],#cartForm quantity-input button');
    if (!control || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button!==0) return;
    event.preventDefault();event.stopImmediatePropagation();
    if (cartUpdating) return;
    if (control.matches('[data-pt-cart-clear]')) {changeCart(control,{},true);return;}
    const input = control.closest('tr')?.querySelector('input[data-line]');
    const key = control.dataset.ptCartRemove || input?.dataset.line;
    if (!key) return;
    let quantity = 0;
    if (control.matches('button')) {
      quantity = Math.max(0,Number(input.value)+(control.name==='plus'?1:-1));
    }
    changeCart(control,{id:key,quantity},false);
  },true);
  document.addEventListener('submit', event => {
    if(cartUpdating && event.target.id==='cartForm'){event.preventDefault();event.stopImmediatePropagation();}
  },true);

  window.PTDiscounts={
    go:async function(destination){
      await ready;
      await run(()=>reconcile(firstCode));
      if(window.PTCart && (!destination || /\/cart\/?$/.test(destination)))return window.PTCart.open();
      location.assign(destination || root+'cart');
    },
    refresh:()=>run(async()=>{await reconcile();return cart;}),
    add:(items,offer)=>run(async()=>{if(!cart?.item_count)cart=await request('cart/update.js',{updates:{}});await request('cart/add.js',{items});try{await reconcile(offer);return cart;}catch(e){e.cartAdded=true;throw e;}}),
    change:(key,quantity)=>run(async()=>{cart=await request('cart/change.js',{id:key,quantity});await reconcile();return cart;}),
    apply:offer=>run(async()=>{await reconcile(offer);return cart;}),
    checkout:()=>run(async()=>{await reconcile();if(cart.item_count)location.assign(root+'checkout');}),
    render:render,
    ready:null
  };
  const ready = run(async()=>{
    const changed=await reconcile(incoming);
    if(incoming){url.searchParams.delete('pt_offer');url.searchParams.delete('discount');history.replaceState(null,'',url.pathname+url.search+url.hash);}
    if(isCart && (changed || incoming)){location.reload();return;}
    render();
  });
  window.PTDiscounts.ready=ready;
  document.addEventListener('DOMContentLoaded',()=>{
    render();

  });
  document.addEventListener('submit',function(event){
    if(!event.submitter || !(event.submitter.name==='checkout' || event.submitter.matches('[data-main-checkout]')))return;
    event.preventDefault();event.stopImmediatePropagation();
    run(async()=>{await reconcile();location.assign(root+'checkout');}).catch(()=>{});
  },true);
  document.addEventListener('click',function(event){
    const link=event.target.closest('a[href]');if(!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button!==0)return;
    const target=new URL(link.href,location.href);if(target.origin!==location.origin)return;
    if(/\/checkout\/?$/.test(target.pathname)){
      event.preventDefault();event.stopImmediatePropagation();run(async()=>{await reconcile();location.assign(target.href);}).catch(()=>{});return;
    }
    const match=target.pathname.match(/\/discount\/([^/]+)/);
    const offer=match?decodeURIComponent(match[1]):target.searchParams.get('discount');
    if(!offer)return;
    event.preventDefault();event.stopImmediatePropagation();
    run(async()=>{
      await reconcile(offer);
      if(match){const dest=new URL(target.searchParams.get('redirect')||root+'cart',location.origin);location.assign(dest.origin===location.origin?dest.href:root+'cart');return;}
      target.searchParams.delete('discount');location.assign(target.href);
    }).catch(()=>{});
  },true);
  window.addEventListener('pageshow',()=>{if(cart)run(async()=>{const changed=await reconcile();if(changed&&isCart)location.reload();}).catch(()=>{});});
  window.addEventListener('focus',()=>{if(cart)run(async()=>{const changed=await reconcile();if(changed&&isCart)location.reload();}).catch(()=>{});});
  setInterval(()=>{if(!document.hidden&&cart&&codes(cart).includes(firstCode))run(async()=>{const changed=await reconcile();if(changed&&isCart)location.reload();}).catch(()=>{});},60000);
})();
